import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const banner = {
  state: {
  },
  getters: {
    getnavigationtype(){
         let type = (navigator.userAgent.includes('Android')) ? 'android' : false;
         (!!!type) ? type = ((navigator.userAgent.includes('Mac')) ? 'ios' : 'other'): 'other';
         return type;
    },
    getcanishow: function () {
      
        let canIshow = false;
        if (!!!window.sessionStorage.getItem('_showBanner')) {
        window.sessionStorage.setItem('_showBanner', true);
        canIshow= true;
        }
        return canIshow
    },
    getLastBanner(){
        let lastbanner = window.localStorage.getItem('lastbanner');
        lastbanner = (!!!lastbanner) ? 1 : lastbanner;
        return lastbanner;
    }
  },
  actions: {
      cambiarBanner({commit}, idbanner) {
        commit('setBanner',idbanner)
      }
  },
  mutations: {
    setBanner(state,idbanner){
        window.localStorage.setItem('lastbanner',idbanner);
    }
  }
}

export default banner;



// WEBPACK FOOTER //
// ./src/store/banner.js